import React from 'react';
import { DollarSign } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const CollectionPage = () => {
  const serviceData = {
    icon: DollarSign,
    nameAr: 'دائرة التحصيل والتسويات',
    nameEn: 'Collection and Settlements Department',
    taglineAr: 'تحصيل المستحقات وحل النزاعات المالية ودياً',
    taglineEn: 'Debt collection and amicable resolution of financial disputes',
    
    descriptionAr: [
      'دائرة التحصيل والتسويات في وازن متخصصة في تحصيل المستحقات المالية سواءً بالطرق الودية أو القضائية. نعتمد على استراتيجيات فعالة لضمان استرداد حقوق عملائنا بأسرع وقت وأقل تكلفة.',
      'نقدم حلولاً متكاملة تشمل التفاوض، التسويات الودية، وإجراءات التحصيل القضائي عند الضرورة، مع الحفاظ على العلاقات التجارية قدر الإمكان.'
    ],
    descriptionEn: [
      'Wazin\'s Collection and Settlements Department specializes in debt collection whether through amicable or judicial means. We rely on effective strategies to ensure recovery of our clients\' rights in the shortest time and at the lowest cost.',
      'We provide comprehensive solutions including negotiation, amicable settlements, and judicial collection procedures when necessary, while maintaining business relationships as much as possible.'
    ],

    services: [
      {
        nameAr: 'تحصيل الديون التجارية نيابة عن الأفراد والشركات',
        nameEn: 'Collecting commercial debts on behalf of individuals and companies',
        descAr: 'تحصيل المستحقات المالية والديون التجارية بالوسائل القانونية المتاحة',
        descEn: 'Collecting financial dues and commercial debts through available legal means'
      },
      {
        nameAr: 'إعداد وإرسال خطابات المطالبة الرسمية للمدينين',
        nameEn: 'Preparing and sending official demand letters to debtors',
        descAr: 'إعداد خطابات المطالبة الرسمية وإرسالها للمدينين قبل اتخاذ الإجراءات القضائية',
        descEn: 'Preparing official demand letters and sending them to debtors before taking legal actions'
      },
      {
        nameAr: 'التفاوض لعقد التسويات الودية قبل اللجوء للتقاضي',
        nameEn: 'Negotiating amicable settlements before resorting to litigation',
        descAr: 'إجراء مفاوضات مع المدينين للوصول إلى تسويات ودية ترضي جميع الأطراف',
        descEn: 'Conducting negotiations with debtors to reach amicable settlements satisfactory to all parties'
      },
      {
        nameAr: 'إعداد محاضر واتفاقيات التسوية وسداد الديون',
        nameEn: 'Preparing settlement minutes and debt payment agreements',
        descAr: 'صياغة وإعداد اتفاقيات التسوية ومحاضر الصلح بين الأطراف',
        descEn: 'Drafting and preparing settlement agreements and reconciliation minutes between parties'
      },
      {
        nameAr: 'متابعة تنفيذ خطط السداد المتفق عليها مع المدينين',
        nameEn: 'Following up implementation of agreed payment plans with debtors',
        descAr: 'متابعة دورية لالتزام المدينين بخطط السداد والجداول الزمنية المتفق عليها',
        descEn: 'Periodic follow-up of debtors commitment to agreed payment plans and schedules'
      },
      {
        nameAr: 'إدارة التحصيل القضائي بالتنسيق مع دائرة التقاضي',
        nameEn: 'Managing judicial collection in coordination with Litigation Department',
        descAr: 'رفع قضايا التحصيل القضائي ومتابعتها بالتنسيق مع دائرة التقاضي',
        descEn: 'Filing judicial collection cases and following them up in coordination with Litigation Department'
      },
      {
        nameAr: 'تحصيل الشيكات المرتجعة والمستحقات المالية',
        nameEn: 'Collecting bounced checks and financial dues',
        descAr: 'متابعة تحصيل الشيكات المرتجعة واتخاذ الإجراءات القانونية اللازمة',
        descEn: 'Following up collection of bounced checks and taking necessary legal actions'
      },
      {
        nameAr: 'تحصيل الفواتير المتعثرة والمطالبات التجارية',
        nameEn: 'Collecting overdue invoices and commercial claims',
        descAr: 'متابعة تحصيل الفواتير التجارية المتأخرة والمطالبات المالية',
        descEn: 'Following up collection of overdue commercial invoices and financial claims'
      },
      {
        nameAr: 'إعداد تقارير دورية عن حالة المطالبات والتحصيل',
        nameEn: 'Preparing periodic reports on claims and collection status',
        descAr: 'تقديم تقارير دورية مفصلة عن حالة التحصيل ونسب الاسترداد',
        descEn: 'Providing detailed periodic reports on collection status and recovery rates'
      },
      {
        nameAr: 'تقديم توصيات قانونية وإجرائية حول جدوى الاستمرار في التحصيل أو التسوية',
        nameEn: 'Providing legal and procedural recommendations on feasibility of continuing collection or settlement',
        descAr: 'تقديم المشورة القانونية حول الخيارات المتاحة وجدوى استمرار التحصيل',
        descEn: 'Providing legal advice on available options and feasibility of continuing collection'
      }
    ],

    specializations: [
      { ar: 'تحصيل الديون التجارية', en: 'Commercial Debt Collection' },
      { ar: 'تحصيل الشيكات المرتجعة', en: 'Bounced Check Collection' },
      { ar: 'تحصيل الإيجارات', en: 'Rent Collection' },
      { ar: 'تسوية النزاعات المالية', en: 'Financial Dispute Settlement' },
      { ar: 'تحصيل مستحقات المقاولات', en: 'Contracting Dues Collection' },
      { ar: 'إعادة هيكلة الديون', en: 'Debt Restructuring' },
      { ar: 'التحصيل من الشركات المتعثرة', en: 'Collection from Distressed Companies' },
      { ar: 'تحصيل الفواتير المستحقة', en: 'Outstanding Invoice Collection' },
      { ar: 'التحصيل الدولي', en: 'International Collection' },
      { ar: 'مطالبات التأمين', en: 'Insurance Claims' }
    ],

    faqs: [
      {
        questionAr: 'ما الفرق بين التحصيل الودي والقضائي؟',
        questionEn: 'What is the difference between amicable and judicial collection?',
        answerAr: 'التحصيل الودي يتم خارج المحاكم من خلال التفاوض والإقناع، وهو أسرع وأقل تكلفة. أما التحصيل القضائي فيتم عبر رفع دعوى قضائية وتنفيذ الحكم، ويُلجأ إليه عند فشل الطرق الودية.',
        answerEn: 'Amicable collection is done outside courts through negotiation and persuasion, and is faster and less costly. Judicial collection is done by filing a lawsuit and executing judgment, and is resorted to when amicable means fail.'
      },
      {
        questionAr: 'كم تستغرق عملية التحصيل؟',
        questionEn: 'How long does the collection process take?',
        answerAr: 'التحصيل الودي قد يستغرق من أسبوع إلى شهرين، بينما التحصيل القضائي قد يستغرق من 3 إلى 6 أشهر حسب تعقيد القضية واستجابة المدين.',
        answerEn: 'Amicable collection may take one week to two months, while judicial collection may take 3 to 6 months depending on case complexity and debtor response.'
      },
      {
        questionAr: 'ما نسبة نجاح التحصيل؟',
        questionEn: 'What is the collection success rate?',
        answerAr: 'نحقق معدل نجاح يتجاوز 85% في التحصيل الودي، و95% في التحصيل القضائي بعد صدور الحكم النهائي، بفضل خبرتنا واستراتيجياتنا المتطورة.',
        answerEn: 'We achieve a success rate exceeding 85% in amicable collection and 95% in judicial collection after final judgment, thanks to our expertise and advanced strategies.'
      },
      {
        questionAr: 'هل تتقاضون أتعاباً مقدماً؟',
        questionEn: 'Do you charge upfront fees?',
        answerAr: 'نقدم خيارات مرنة للأتعاب، بما في ذلك نسبة من المبلغ المحصل، أو أتعاب ثابتة حسب الاتفاق. نحرص على تقديم حلول مناسبة لجميع العملاء.',
        answerEn: 'We offer flexible fee options, including a percentage of collected amount or fixed fees as agreed. We ensure suitable solutions for all clients.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default CollectionPage;